import {Alert} from 'platform/components';
import {Show} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {isNotEmpty, isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {RentalResourceCalendarEvent} from '../types/RentalResourceCalendarEvent';

interface RentalPeriodConflictAlertProps extends RequiredTestIdProps {
  events: RentalResourceCalendarEvent[];
}

export function RentalPeriodConflictAlert(props: RentalPeriodConflictAlertProps) {
  const formatDateTime = useDateTimeFormatter();

  const describeEvent = (event: RentalResourceCalendarEvent) => {
    const subject =
      event.type === 'block'
        ? i18n.t('entity.rental.labels.vehicleBlock')
        : (event.rentalOrder?.number ?? i18n.t('entity.rentalOrder.labels.rentalOrder'));

    return [
      subject,
      event.rentalOrder?.customerName,
      `${formatDateTime('dateTimeShort', event.start)} - ${formatDateTime('dateTimeShort', event.end)}`,
    ]
      .filter(isNotNil)
      .join(' · ');
  };

  return (
    <Show when={isNotEmpty(props.events)}>
      <Alert
        layout="detailed"
        variant="warning"
        title={i18n.t('entity.rental.hints.periodOverlapsExistingEvents')}
        message={props.events.map(describeEvent)}
        data-testid={suffixTestId('periodConflict', props)}
      />
    </Show>
  );
}
